import type { UserMessage } from "@spwn/types/firebase/firestore";

/**
 * コメント欄に表示するコメント。個人ブロックで墓標にしたものは印が付く。
 * 管理者 BAN の墓標とは文言が違うため、表示側はこれで見分ける。
 */
export type DisplayComment = UserMessage & { isPersonallyBlocked?: boolean };

/**
 * 出ていた分を黙って消すと、ブロックした瞬間にコメント欄が詰めて動き読んでいた位置を
 * 見失う。管理者ブロック (StreamingCommentItemV2.tsx の isBan 分岐) も表示済みは
 * トゥームストーンに変わるので、そちらと挙動を揃える。
 *
 * 自分のコメント (uid === selfUid) は、万一自分の uid が blockedUserIds に紛れても
 * 消さない二重保険として常に残す。
 */
export const applyBlockedComments = ({
  comments,
  blockedUserIds,
  tombstoneCommentIds,
  selfUid,
}: {
  comments: UserMessage[];
  blockedUserIds: string[];
  tombstoneCommentIds: ReadonlySet<string>;
  selfUid: string | undefined;
}): DisplayComment[] =>
  comments
    .map((comment) => {
      if (comment.uid === selfUid) return comment;

      if (blockedUserIds.includes(comment.uid)) {
        const isTombstoneTarget =
          comment._id !== undefined && tombstoneCommentIds.has(comment._id);
        if (!isTombstoneTarget) return undefined;
        // 既に BAN 済みのものは管理者の墓標のまま出す。
        return comment.isBan
          ? comment
          : { ...comment, isBan: true, isPersonallyBlocked: true };
      }

      return comment;
    })
    .filter((comment) => comment !== undefined);
